(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[610],{

/***/ 5100:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/play-to-earn/games/[id]",
      function () {
        return __webpack_require__(8427);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ PlayToEarnGame; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./styles/layout.module.css
var layout_module = __webpack_require__(7272);
var layout_module_default = /*#__PURE__*/__webpack_require__.n(layout_module);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 37 modules
var esm = __webpack_require__(3562);
// EXTERNAL MODULE: ./src/util/src/i18next.ts
var i18next = __webpack_require__(4873);
// EXTERNAL MODULE: ./styles/guides.module.css
var guides_module = __webpack_require__(1775);
var guides_module_default = /*#__PURE__*/__webpack_require__.n(guides_module);
// EXTERNAL MODULE: ./src/Generic/models/UrlPattern/replaceUrlPattern.ts
var replaceUrlPattern = __webpack_require__(9978);
;// CONCATENATED MODULE: ./src/Social/models/SocialChannel/getFollowUrl.ts

function getFollowUrl(channel) {
    return (0,replaceUrlPattern/* replaceUrlPattern */.C)(channel.type.followUrlPattern, {
        slug: channel.slug
    });
}

// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
// EXTERNAL MODULE: ./src/Generic/models/Id.ts
var Id = __webpack_require__(7469);
;// CONCATENATED MODULE: ./pages/play-to-earn/games/[id].tsx










var __N_SSG = true;
function PlayToEarnGame(props) {
    var game = props.game;
    var t = (0,esm/* useTranslation */.$G)(translationNamespaces).t;
    var tc = (0,i18next/* withNamespace */.Q)(t, "common");
    var title = game.name;
    var description = game.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        className: (layout_module_default()).main,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (guides_module_default()).instructionSubheader,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    height: 300,
                    src: game.image,
                    alt: game.name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: game.channels.map(function(channel) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: getFollowUrl(channel),
                                children: channel.type.network.name
                            }),
                            ": ",
                            channel.subscriberCount
                        ]
                    }, getFollowUrl(channel));
                })
            })
        ]
    });
};
var ParamsSchema = lib.z.object({
    id: Id/* IdSchema */.KI
});
var translationNamespaces = [
    "play-to-earn-games",
    "play-to-earn",
    "common"
];


/***/ }),

/***/ 7469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KI": function() { return /* binding */ IdSchema; },
/* harmony export */   "hH": function() { return /* binding */ fromStringToId; }
/* harmony export */ });
/* unused harmony exports idAllowedSymbols, validateId, byId, getById, toSystemId */
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1604);
/* harmony import */ var _util_src_ensure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6600);


var idAllowedSymbols = [
    "\\w",
    "\\d",
    "-",
    "_",
    ".",
    ":"
];
var idAllowedSymbolsEscapedString = idAllowedSymbols.join("");
var idRegExp = new RegExp("^[".concat(idAllowedSymbolsEscapedString, "]+$"));
var idReplaceUnwantedCharactersRegExp = new RegExp("[^".concat(idAllowedSymbolsEscapedString, "]"), "g");
var IdSchema = zod__WEBPACK_IMPORTED_MODULE_1__.z.string().min(1).regex(idRegExp);
function validateId(id) {
    return IdSchema.parse(id);
}
function byId(id) {
    return function(object) {
        return object.id === id;
    };
}
function getById(objects, id) {
    return ensure(objects.find(byId(id)), err("Cannot get object by id: ".concat(id)));
}
function fromStringToId(string) {
    return string.replace(idReplaceUnwantedCharactersRegExp, "");
}
function toSystemId(id) {
    return id.replace(/\s+/g, "_");
}


/***/ }),

/***/ 7117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ UrlSchema; }
/* harmony export */ });
/* unused harmony export validateUrl */
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1604);

var UrlSchema = zod__WEBPACK_IMPORTED_MODULE_0__.z.string().url().min(1);
function validateUrl(url) {
    return UrlSchema.parse(url);
}


/***/ }),

/***/ 9786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ie": function() { return /* binding */ UrlPatternSchema; },
/* harmony export */   "UV": function() { return /* binding */ substitutionRegExp; }
/* harmony export */ });
/* unused harmony exports UrlPatternsSchema, UrlPatternUidSchema, parseUrlPattern, parseUrlPatterns, parseUrlPatternUid */
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1604);
/* harmony import */ var src_util_src_zod__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6338);
/* harmony import */ var _Url__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7117);



var substitutionRegExp = /\{\{[^}]+\}\}/;
var UrlPatternSchema = _Url__WEBPACK_IMPORTED_MODULE_1__/* .UrlSchema.regex */ .z.regex(substitutionRegExp);
var UrlPatternsSchema = zod__WEBPACK_IMPORTED_MODULE_2__.z.array(UrlPatternSchema).superRefine((0,src_util_src_zod__WEBPACK_IMPORTED_MODULE_0__/* .getDuplicatesRefinement */ .$K)("UrlPattern", parseUrlPatternUid));
var UrlPatternUidSchema = _Url__WEBPACK_IMPORTED_MODULE_1__/* .UrlSchema */ .z;
function parseUrlPattern(urlPattern) {
    return UrlPatternSchema.parse(urlPattern);
}
function parseUrlPatterns(urlPatterns) {
    return UrlPatternsSchema.parse(urlPatterns);
}
function parseUrlPatternUid(urlPatternUid) {
    return UrlPatternUidSchema.parse(urlPatternUid);
}


/***/ }),

/***/ 9978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ replaceUrlPattern; }
/* harmony export */ });
/* harmony import */ var _UrlPattern__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9786);
/* harmony import */ var _util_src_chai__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5469);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


function replaceUrlPattern(pattern1, replacements) {
    var entries = Object.entries(replacements);
    var result = entries.reduce(function(pattern, param) {
        var _param = _slicedToArray(param, 2), search = _param[0], replace = _param[1];
        return pattern.replace("{{".concat(search, "}}"), replace);
    }, pattern1);
    (0,_util_src_chai__WEBPACK_IMPORTED_MODULE_1__/* .expect */ .l)(result).not.to.match(_UrlPattern__WEBPACK_IMPORTED_MODULE_0__/* .substitutionRegExp */ .UV) // should not contain unreplaced substitutions
    ;
    return result;
}


/***/ }),

/***/ 5469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ expect; }
/* harmony export */ });
/* harmony import */ var chai__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2757);
/* harmony import */ var chai_as_promised__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6495);
/* harmony import */ var chai_as_promised__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(chai_as_promised__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var chai_things__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4450);
/* harmony import */ var chai_things__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(chai_things__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var chai_subset__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2249);
/* harmony import */ var chai_subset__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(chai_subset__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var chai_bignumber__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6396);
/* harmony import */ var chai_bignumber__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(chai_bignumber__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4431);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(bignumber_js__WEBPACK_IMPORTED_MODULE_5__);
// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="./chai-bignumber.d.ts" />






chai__WEBPACK_IMPORTED_MODULE_0__/* ["default"].use */ .ZP.use((chai_as_promised__WEBPACK_IMPORTED_MODULE_1___default()));
chai__WEBPACK_IMPORTED_MODULE_0__/* ["default"].use */ .ZP.use((chai_things__WEBPACK_IMPORTED_MODULE_2___default()));
chai__WEBPACK_IMPORTED_MODULE_0__/* ["default"].use */ .ZP.use((chai_subset__WEBPACK_IMPORTED_MODULE_3___default()));
chai__WEBPACK_IMPORTED_MODULE_0__/* ["default"].use */ .ZP.use(chai_bignumber__WEBPACK_IMPORTED_MODULE_4___default()((bignumber_js__WEBPACK_IMPORTED_MODULE_5___default())));
var expect = chai__WEBPACK_IMPORTED_MODULE_0__/* ["default"].expect */ .ZP.expect;


/***/ }),

/***/ 6600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cn": function() { return /* binding */ err; },
/* harmony export */   "zx": function() { return /* binding */ ensure; }
/* harmony export */ });
/* unused harmony exports defaultCollectionFindThrowback, ensureStatic, checkAll, ensureFind, tb */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err1) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err1);
            }
            _next(undefined);
        });
    };
}


var defaultCollectionFindThrowback = function() {
    throw new Error("Can't find object in collection");
};
var err = function(message) {
    return function() {
        throw new Error(message);
    };
};
function ensure(object) {
    var throwback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultCollectionFindThrowback;
    if (object === null || object === undefined) {
        throw throwback();
    } else {
        return object;
    }
}
function ensureStatic(object, error) {
    if (object === null || object === undefined) {
        throw error !== null && error !== void 0 ? error : new Error("Can't find object in collection");
    } else {
        return object;
    }
}
function checkAll(objects) {
    if (!objects.every(identity)) {
        throw new Error("Some objects are falsy: \n\n".concat(JSON.stringify(objects)));
    } else {
        return objects;
    }
}
function ensureFind(collection, filter, error) {
    var object = collection.find(filter);
    if (object === null || object === undefined) {
        throw error !== null && error !== void 0 ? error : new Error("Can't find an object in a collection using filter: " + filter.toString());
    } else {
        return object;
    }
}
var tb = function(err2) {
    return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", err2);
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
};


/***/ }),

/***/ 4873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ withNamespace; }
/* harmony export */ });
function withNamespace(t, ns) {
    return function(key) {
        return t(key, {
            ns: ns
        });
    };
}


/***/ }),

/***/ 2927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RY": function() { return /* binding */ toUidFromSchema; },
/* harmony export */   "dP": function() { return /* binding */ byUid; }
/* harmony export */ });
/* unused harmony exports toUid, fromUid */
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3549);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6388);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function toUid(obj) {
    for(var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        keys[_key - 1] = arguments[_key];
    }
    return pick.apply(void 0, [
        obj
    ].concat(_toConsumableArray(keys)));
}
function toUidFromSchema(obj, schema) {
    return lodash_es__WEBPACK_IMPORTED_MODULE_0__/* ["default"].apply */ .Z.apply(void 0, [
        obj
    ].concat(_toConsumableArray(Object.keys(schema.shape))));
}
// export function toUid<T>(array: Array<T>): string {
//   return JSON.stringify(array)
// }
function fromUid(uid) {
    return JSON.parse(uid);
}
function byUid(getUid, holder) {
    var uid = getUid(holder);
    // console.log('uid', uid)
    return function($obj) {
        var $uid = getUid($obj);
        // console.log('$uid', $uid)
        return (0,lodash_es__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(uid, $uid);
    };
} // export function getCompositeUid<O extends Record<string, unknown>>(object: O, map: Record<keyof O, GetUid<unknown>>) {
 //   return JSON.stringify(Object.assign({}, object, { items: schedule.items.map(getScheduleItemUid) }))
 // }


/***/ }),

/***/ 6338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$K": function() { return /* binding */ getDuplicatesRefinement; },
  "QC": function() { return /* binding */ getFinder; },
  "VE": function() { return /* binding */ getInserter; },
  "oY": function() { return /* binding */ getName; }
});

// UNUSED EXPORTS: getDuplicateStats, getErrorReports, getGenericInserter, getMultiInserter, getUniqueCountStats, insert, mustIncludeAllOf, parse, parseWithSchema

// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
// EXTERNAL MODULE: ./node_modules/lodash-es/isEqual.js + 43 modules
var isEqual = __webpack_require__(6388);
;// CONCATENATED MODULE: ./src/util/src/lodash.ts

function isEqualBy(a, b, getter) {
    return (0,isEqual/* default */.Z)(getter(a), getter(b));
}
function isSubset(set, subset) {
    return difference(set, subset).length === 0;
}
function mergeWithArrays(object, source1, source2) {
    return mergeWith(object, source1, source2, function(a, b) {
        if (isArray(a) && isArray(b)) {
            return b.concat(a);
        }
    });
}
var notInBy = function(getUid) {
    return function(elements) {
        return function(element) {
            return !elements.find(function(el) {
                return isEqualBy(el, element, getUid);
            });
        };
    };
};

// EXTERNAL MODULE: ./src/util/src/uid.ts
var uid = __webpack_require__(2927);
// EXTERNAL MODULE: ./src/util/src/ensure.ts
var ensure = __webpack_require__(6600);
;// CONCATENATED MODULE: ./src/util/src/zod.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





function getDuplicatesRefinement(name, getUniqueValue) {
    return function(objects, context) {
        var stats = getDuplicateStats(objects, getUniqueValue);
        stats.map(function(err1) {
            return context.addIssue({
                code: lib/* ZodIssueCode.custom */.NL.custom,
                params: err1,
                message: "Found ".concat(name, " duplicates: ").concat(JSON.stringify(err1))
            });
        });
    };
}
function getDuplicateStats(objects, getUniqueValue) {
    var stats = getUniqueCountStats(objects, getUniqueValue);
    return stats.filter(function(stat) {
        return stat.count > 1;
    });
}
function getUniqueCountStats(objects, getUniqueValue) {
    var stats1 = [];
    return objects.reduce(function(stats, value) {
        var uid = getUniqueValue(value);
        var index = stats.findIndex(function(s) {
            return (0,isEqual/* default */.Z)(s.uid, uid);
        });
        if (~index) {
            stats[index].count++;
        } else {
            stats.push({
                uid: uid,
                count: 1
            });
        }
        return stats;
    }, stats1);
}
var insert = function(name) {
    return function(schema) {
        return function(getUid) {
            return function(array) {
                return function(object) {
                    var $object = schema.parse(object);
                    var duplicate = array.find(function(o) {
                        return isEqualBy(o, $object, getUid);
                    });
                    if (duplicate) throw new Error("Duplicate ".concat(name, " found: ").concat(JSON.stringify(getUid(duplicate))));
                    array.push($object);
                    return $object;
                };
            };
        };
    };
};
function getGenericInserter(name, schema, getUid) {
    return insert(name)(schema)(getUid);
}
function getInserter(name, schema, getUid, array) {
    return insert(name)(schema)(getUid)(array);
}
function getMultiInserter(name, schema, getUid, array) {
    var inserter = insert(name)(schema)(getUid)(array);
    return function(objects) {
        return objects.map(inserter);
    };
}
function getFinder(getUid, array) {
    return function(uidHolder) {
        return array.find((0,uid/* byUid */.dP)(getUid, uidHolder));
    };
}
function parse(schema, input) {
    var result = schema.safeParse(input);
    if (result.success) {
        return result.data;
    } else {
        console.error("input", input);
        throw result.error;
    }
}
function getName(schema) {
    var description = (0,ensure/* ensure */.zx)(schema.description, (0,ensure/* err */.cn)("Cannot get schema name: ".concat(JSON.stringify(schema))));
    var ref = _slicedToArray(description.split(" "), 1), name = ref[0];
    return name;
}
var mustIncludeAllOf = function(required) {
    return function(elements) {
        return difference(required, elements).length === 0;
    };
};
function getErrorReports(results, schema) {
    var errors = results.reduce(function(reports, result, index) {
        if (result.success) {
            return reports;
        } else {
            var report = {
                index: index,
                error: result.error
            };
            return reports.concat([
                report
            ]);
        }
    }, []);
    return errors;
}
function parseWithSchema(objects, schema) {
    var results = objects.map(function(b) {
        return schema.safeParse(b);
    });
    return results.map(function(result, index) {
        if (result.success) {
            return result.data;
        } else {
            throw {
                index: index,
                error: result.error
            };
        }
    });
}


/***/ }),

/***/ 1775:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"instruction-header":"guides_instruction-header__FBi6Z","instruction-subheader":"guides_instruction-subheader__9Md2b"};

/***/ }),

/***/ 7272:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"layout_container__5R52X","hero":"layout_hero__sdPiy","main":"layout_main__j5lor","footer":"layout_footer__a_vOy","title":"layout_title__zDlUa","subtitle":"layout_subtitle__Wt4qK","code":"layout_code__EMwy8","grid":"layout_grid__gVdal","card":"layout_card__dnilS","logo":"layout_logo__ZuUu7","list":"layout_list__0_v1E"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [604,546,364,774,888,179], function() { return __webpack_exec__(5100); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);